import { Expose } from 'class-transformer';

import { Default } from '@lib/common/decorators';
import { SnModel } from '@lib/common/models';

export class SnLayerSetting extends SnModel {
  @Expose()
  @Default(false)
  public enableCadSoundNotification?: boolean;

  @Expose()
  @Default(false)
  public enableCadToastNotification?: boolean;

  constructor(data: any = {}) {
    super();
    this.fromJSON(data);
  }
}
